import { render, staticRenderFns } from "./PhonesList.vue?vue&type=template&id=036f5454&scoped=true"
import script from "./PhonesList.vue?vue&type=script&lang=ts"
export * from "./PhonesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f5454",
  null
  
)

export default component.exports